
import React, { Component } from 'react';
import axios from 'axios';
import {API_URL} from '../../../constants';
import Error from '../../../components/Error/error';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';

const CssBody = ".bodyhtml { margin: 0; padding: 0 !important; mso-line-height-rule: exactly; background-color: #f9f9fa; height: 100% !important; width: 100% !important; font-family: 'Roboto', sans-serif; font-weight: 400;font-size: 14px;color: rgba(0, 0, 0, 0.4); }";
const cssTable = ".tablePrincipal {max-width: 600px; margin: 0 auto;} .tableSecundario { margin: auto; } .tdInterno { background: #ffffff;padding: 0 2em 0 0; text-align: center } .table1 {width:100%!important;min-width:100%!important}";

const Css =" @media only screen and (min-device-width: 320px) and (max-device-width: 374px) {u ~ div .email-container { min-width: 320px !important; } } @media only screen and (min-device-width: 375px) and (max-device-width: 413px) { u ~ div .email-container { min-width: 375px !important; } } @media only screen and (min-device-width: 414px) { u ~ div .email-container { min-width: 414px !important; } }";
const CssDiv =".div1 {text-align: center; background: linear-gradient(0deg , transparent,#fff ) 220px 0 no-repeat, linear-gradient(131deg , #f3f5fc 75%, transparent 0%) left no-repeat;width: 200px;height: 79px;line-height: 60px;color: white;margin: 0px;position: relative;}"

export default class Mail extends Component {

    state = {
        resource: [],
        response: [],
        optionsTipoRecurso: [],
        error: [],
      }


    render() {
        return (
            <div>
            <html lang="en" xmlns="http://www.w3.org/1999/xhtml">
                <head>
                    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
                    <meta name="viewport" content="width=device-width" />
                    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
                    <meta name="x-apple-disable-message-reformatting" />
                    <title>BOLETIN PROM PERU</title>

                    <style>
                        @import url("https://fonts.googleapis.com/css?family=Roboto&display=swap");
                        {Css}
                    </style>


                </head>
                <body width="100%" className="bodyhtml" >
                    <table className="tablePrincipal email-container">
                        <tr>
                            <td>
                                <table align="center" role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" className="tableSecundario">
                                    <tbody>
                                        <tr>
                                            <td className="tdInterno">
                                                <table role="presentation" border="0" cellspacing="0" cellpadding="0" width="100%" className="table1">
                                                <tbody>
                                                    <tr>
                                                        <td align="left" valign="middle" processed="true">
                                                            <div className="div1">
                                                                <img style="padding:22px;" src="img/logo.png" />
                                                            </div>
                                                        </td>
                                                        <td valign="middle" width="100%" align="right" processed="true">
                                                            <span style="color:#43434b;">No ves el contenido?</span>
                                                            <a style="font-weight: bold;color: #d52b1e;" href="#">clic aquí</a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </table>
                </body>
            </html>
            </div>
            )
    }


    componentDidMount(){
    }
}

